import { castArray, isNil, isString, sortBy } from 'lodash-es';
import { useMemo } from 'react';

import { useCollectionServices } from 'hooks';
import services from 'services';
import { getMainConfig, isAvailable } from 'utils';

export const DEFAULT_PRODUCT_CATEGORY = 'Apps';
const calcDefaultCategory = () => {
  const defaultProductCategoryFromConfig = getMainConfig('defaultProductCategory');
  if (defaultProductCategoryFromConfig === false) {
    return null; // uncategorized
  }
  if (isString(defaultProductCategoryFromConfig)) {
    return defaultProductCategoryFromConfig;
  }
  return DEFAULT_PRODUCT_CATEGORY;
};

const categorizeProducts = (products) => {
  const productsMap = new Map();

  products.forEach((product) => {
    const { category } = product;
    const isCategoryInMap = productsMap.has(category);
    productsMap.set(category, isCategoryInMap ? [...productsMap.get(category), product] : castArray(product));
  });

  return productsMap;
};
const useProducts = () => {
  const products = useCollectionServices(services.appFrame.products);

  const categorizedProducts = useMemo(() => {
    const defaultCategory = calcDefaultCategory();
    const availableProducts = sortBy(
      products.filter(({ available }) => isAvailable(available)),
      'order',
    );
    const normalizedProducts = availableProducts.map((product) => {
      if (isNil(defaultCategory) || !product.category) {
        return { ...product, category: defaultCategory };
      }
      return product;
    });

    return categorizeProducts(normalizedProducts);
  }, [products]);

  return categorizedProducts;
};

export default useProducts;
